import { get } from "../base.ehq.model";
import { deserialize } from "../base.serializer";

export const getFeature = async (
  token: string,
  baseUrl: string,
  params?: unknown,
  config?: any
) => {
  const queryPath = `${baseUrl}/features`;
  try {
    const res = await get(token, queryPath, params, config);
    return deserialize(res);
  } catch (err) {
    throw new Error(err);
  }
};
